let searchBtn = document.querySelector('#search-btn');
let searchModule = document.querySelector('#search-module');
let closeSearch = document.querySelector('#close-search');
let searchInput = document.querySelector('#search-input');

let searchBtns = document.querySelectorAll('.summon-search-btn');
searchBtns.forEach(function(item, i){
  item.addEventListener('click', function(event){
    event.preventDefault();

    let clkHeadOne = document.querySelector('#campaigns-dropdown-menu');
    //let clkHeadTwo = document.querySelector('#shop-dropdown-menu');
  
    if (clkHeadOne){
      document.querySelector('#campaigns-dropdown-menu').classList.remove('active');
      document.querySelector('#shop-dropdown-menu').classList.remove('active');
    }

    //console.log("Open Search");
    searchModule.classList.toggle('open');
    searchInput.focus();
  });
});

closeSearch.addEventListener('click', function(event){
  event.preventDefault();
  searchModule.classList.remove('open');
  killOverlay();
});

let formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});


searchInput.addEventListener('keyup', function(){
  let currentValue = this.value;
  let valueSize = currentValue.length;
  let searchResults = document.querySelector('ul.results');
  let viewAllBtn = document.querySelector('.view-all-search');
  let searchHeading = document.querySelector('#search-results .heading');
  let searchSuggestions = document.querySelector('#search-results .suggestions');
  let noResults = document.querySelector('#search-results .no-results');
  searchResults.innerHTML = "";
  viewAllBtn.classList.remove('appear');
  //console.log(currentValue);

  setTimeout(function(){
    if(valueSize > 2){
      viewAllBtn.classList.remove('appear');
      searchResults.innerHTML = "";
      jQuery.getJSON("/search/suggest.json", {
        "q": currentValue,
        "resources": {
          "type": "product",
          "limit": 10,
          "options": {
          "unavailable_products": "show",
            "fields": "title"
          }
        }
      }).done(function(response) {
        searchResults.innerHTML = "";
        let productSuggestions = response.resources.results.products;
        //console.log(productSuggestions.length);
        
        if(productSuggestions.length > 0){
          searchHeading.classList.add('hide');
          searchSuggestions.classList.add('hide');
          noResults.classList.remove('appear');
    
          productSuggestions.forEach(function(product, i){
            // let trimType = product.type.trim();
            // let lowType = trimType.toLowerCase();
            // console.log(lowType);
            // if(lowType == 'wearable object'){
            let theVendor = product.vendor;
            if(theVendor == "Sophie Hidden"){

            } else {
               let url = product.url;
               let image = "";
               if(product.image){
                 image = product.image + '&width=60';
               } else {
                 image = 'https://cdn.shopify.com/s/files/1/0661/3761/files/no-image.png?v=1623960167';
               }
  
              //let image = getSizedImageUrl(image, '80x');
              let title = product.title;
              //console.log(product);
              let handle = product.handle;

              let restrictedHandles = [
                "evil-eye-minaudiere",
                "shell-tear-brooch",
                "onyx-coquille-mirror-with-pearl",
                "sun-sperm-tear-magnifying-glass",
                "climbing-thorn-cigarette-holder",
                "carnelian-flask",
                "three-sisters-bud-vase-carnelian",
                "blood-drop-pill-box-carnelian",
                "three-sisters-bud-vase-jade",
                "three-sisters-bud-vase-moonstone",
                "nautilus-knife-carnelian",
                "pearl-moon-drop-collar",
                "jade-nautilus-comb",
                "toothpick-case",
                "nautilus-case-carnelian",
                "three-green-eyes-lighter-case",
                "large-moonstone-cuff",
                "small-moonstone-cuff",
                "rising-moons-lighter-case",
                "blue-craters-lighter-case",
                "scarab-coffret",
                "xl-circle-bangle",
                "18k-gold-nose-brooch",
                "18k-gold-nautilus-comb",
                "18k-gold-nautilus-collar",
                "18k-gold-nautilus-pill-box",
                "moonrise-cuff-in-moonstone",
              ];

              let dirtyPrice = product.price;
              let price = formatter.format(dirtyPrice);

              if (restrictedHandles.includes(handle)) {
                //console.log("Match found");
                price = "";
              }
    
      
              let singleProduct = '<li class="animate"><div class="left"><a href="' + url + '"><img src="' + image + '" alt="Search Thumbnail"></a></div><div class="right"><a href="' + url + '" class="title">' + title + '</a><a href="' + url + '" class="price">' + price + '</a></div></li>';
      
       
              searchResults.innerHTML = searchResults.innerHTML + singleProduct;
              if(productSuggestions.length >= 5) {
                viewAllBtn.classList.add('appear');
                searchHeading.classList.add('hide');
                searchSuggestions.classList.add('hide');
                noResults.classList.remove('appear');
              }
            }
            // } else {
            //   searchResults.innerHTML = "";
            //   viewAllBtn.classList.remove('appear');
            //   searchHeading.classList.remove('hide');
            //   searchSuggestions.classList.remove('hide');
            //   noResults.classList.add('appear');
            // }
            //console.log(product.title);
          });
          
        } else {
          setTimeout(function(){
            searchResults.innerHTML = "";
            viewAllBtn.classList.remove('appear');
            searchHeading.classList.remove('hide');
            searchSuggestions.classList.remove('hide');
            noResults.classList.add('appear');
          }, 1000);
        }
      });
    } else {
      searchResults.innerHTML = "";
      searchResults.innerHTML = "";
      searchResults.innerHTML = "";
      viewAllBtn.classList.remove('appear');
      noResults.classList.remove('hide');
      searchHeading.classList.remove('hide');
      searchSuggestions.classList.remove('hide');
    }
  }, 500)

  viewAllBtn.addEventListener('click', function(event){
    event.preventDefault();
    document.querySelector('#submit-search-form').click();
  });
});

